// extracted by mini-css-extract-plugin
module.exports = {"button":"PaymentLinkButton_button__E4A5P","icon":"PaymentLinkButton_icon__3xLSs"};